// METKA brand tokens — single source of truth.
//
// Exported variants (CSS vars, Freemarker assigns, C# constants) are
// generated from this file by `scripts/brand-export.mjs`.
// Changes here require re-running `npm run brand:export` and committing
// the regenerated files (enforced by the pre-push hook).

export const brand = {
  color: {
    ink: '#0b1020',
    paper: '#ffffff',
    panel: '#f5f6fb',
    rule: 'rgba(11,16,32,0.10)',
    accent: '#ea580c',
    accent2: '#c2410c',
    subText: 'rgba(11,16,32,0.70)',
    subTextDim: 'rgba(11,16,32,0.55)',
  },
  font: {
    display: 'Manrope, Inter, system-ui, sans-serif',
    body: 'Inter, system-ui, sans-serif',
    mono: "'JetBrains Mono', ui-monospace, Menlo, monospace",
    mark: 'Unbounded, Manrope, sans-serif',
  },
  radius: { sm: 4, md: 6, lg: 8 },
  shadow: { cardOffset: '20px 24px 0 -12px rgba(234,88,12,0.15)' },
  wordmark: {
    orangeCorners: true,
    ratio: 0.4,
  },
} as const

export type Brand = typeof brand
